module.exports = __webpack_public_path__ + "img/edit_square.d2e6c2d2.svg";